<kt-portlet class="knostos-grid">
  <!-- PORTLET LOADING | Binded to TABLE Datasource -->
  <!-- See prop => '~/core/_crud/models/data-sources/_base.datasource.ts' (loading$) -->
  <kt-portlet-header
    title="{{ 'TABLE.RELATIONSHIP_LIST' | translate }}"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddRelation">
          <button
            type="button"
            (click)="addRel(null)"
            mat-raised-button
            color="primary"
            matTooltip="Create new relationship"
            class="margin-2"
          >
            <span class="svg-icon-md" translate="CONTACT_RELATIONSHIP.NEW_CONTACT_RELATIONSHIP">
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              New Relationship
            </span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <!-- end::Header -->

  <!-- start::Body (attribute: ktPortletBody) -->
  <kt-portlet-body>
    <div class="mat-table-wrapper">
      <mat-table
        class="lmat-elevation-z8"
        [dataSource]="dataSource"
        matSort
        matSortActive="_relationshipName"
        matSortDirection="asc"
        matSortDisableClear
      >
        <ng-container matColumnDef="name">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-column"
            translate="CONTACT_RELATIONSHIP.TABLE.NAME"
            >Name
          </mat-header-cell>
          <mat-cell
            *matCellDef="let relationship"
            class="mat-column gl-block clickable"
            matTooltip="View Contact"
            (dblclick)="editContact(relationship)"
          >
            <span>{{ getFullName(relationship) }}</span>
            <i
              *ngIf="relationship.is_prime"
              class="flaticon2-correct text-success icon-md ml-2"
            ></i>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="relation_type_id">
          <mat-header-cell *matHeaderCellDef class="mat-column">Category </mat-header-cell>
          <mat-cell *matCellDef="let relationship" class="mat-column">
            {{ relationship.relation_type }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="description">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-column"
            translate="CONTACT_RELATIONSHIP.TABLE.DESCRIPTION"
          >
            Description
          </mat-header-cell>
          <mat-cell *matCellDef="let relationship" class="mat-column">
            <mat-form-field
              *ngIf="relationship._isEditMode"
              class="mat-form-field-fluid"
              appearance="fill"
            >
              <mat-label translate="CONTACT_RELATIONSHIP.FORM.DESCRIPTION">Description</mat-label>
              <input matInput formControlName="editDescription" />
            </mat-form-field>
            <span *ngIf="!relationship._isEditMode">{{
              relationship.relationship_description
            }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="classification">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-column"
            translate="CONTACT_RELATIONSHIP.TABLE.CLASSIFICATION"
          >
            Classification
          </mat-header-cell>
          <mat-cell *matCellDef="let relationship" class="mat-column">
            <span
              class="svg-icon svg-icon-md svg-icon-success cursor-pointer"
              style="display: flex; height: 30px"
            >
              <span
                class="m-1"
                style="display: flex; align-items: center"
                *ngIf="relationship.financial_responsible"
                matTooltip="Financial Responsible"
                inlineSVG="./assets/media/svg/icons/General/dollar.svg"
              ></span>
              <span
                class="m-1"
                style="display: flex; align-items: center"
                *ngIf="relationship.emergency_contact"
                matTooltip="Emergency Contact"
                inlineSVG="./assets/media/svg/icons/General/siren.svg"
              ></span>
              <span
                class="m-1"
                style="display: flex; align-items: center"
                *ngIf="relationship.phi_authorized"
                matTooltip="PHI Authorized"
                inlineSVG="./assets/media/svg/icons/General/hipaa_seal.svg"
              ></span>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="mat-column-actions" translate="TABLE.ACTIONS">
            Actions
          </mat-header-cell>
          <mat-cell *matCellDef="let rel" class="mat-column-actions">
            <div
              *ngxPermissionsOnly="'canAccessFilteredView'"
              [ngbTooltip]="(isFilteredView$ | async) ? 'End Session' : 'Focused View'"
              class="btn btn-icon btn-clean btn-dropdown btn-lg m-0 pulse pulse-primary"
              (click)="openFilteredViewDialog(rel)"
            >
              <span class="svg-icon svg-icon-xl svg-icon-primary">
                <span
                  inlineSVG="./assets/media/svg/icons/General/focus-svgrepo-com.svg"
                  *ngIf="!(isFilteredView$ | async)"
                ></span>
                <span
                  inlineSVG="./assets/media/svg/icons/General/sign_out.svg"
                  *ngIf="isFilteredView$ | async"
                ></span>
              </span>
            </div>
            <ng-template ngxPermissionsOnly="canEditRelation">
              <button
                *ngIf="!isViewMode"
                type="button"
                mat-icon-button
                color="primary"
                (click)="editRelationshipButtonOnClick(rel)"
                class="margin-2"
                matTooltip="Edit Relationship"
              >
                <span class="svg-icon svg-icon-md svg-icon-primary">
                  <span inlineSVG="./assets/media/svg/icons/General/edit_icon.svg"></span>
                </span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canDeleteRelation">
              <button
                *ngIf="!isViewMode"
                mat-icon-button
                color="warn"
                type="button"
                (click)="deleteRel(rel)"
                matTooltip="Delete Relationship"
                class="margin-2"
              >
                <span class="svg-icon svg-icon-md svg-icon-danger">
                  <span inlineSVG="./assets/media/svg/icons/General/delete_icon.svg"></span>
                </span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <div class="mat-table__message" *ngIf="contactRelationshipsResult.length == 0 && !loading">
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <div class="mat-table__message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table__bottom" hidden>
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
    <!-- end: BOTTOM -->
  </kt-portlet-body>
  <!-- end::Body -->
</kt-portlet>
